import React from 'react';
import { webSiteUrlRegex } from 'utils/helpers';
import { ValidationErrors } from 'constants/validations';
import { useIndustryQuery, useSupplierTypesListQuery } from 'api';
import {
  Checkbox,
  Col,
  CountrySelect,
  Form,
  FormModal,
  Input,
  LanguageSelect,
  Row,
  Select,
  Typography,
} from 'components';
import { useAddSupplier } from './useAddSupplier';

const { Item } = Form;
const { TextArea } = Input;

export interface IAddSupplierModal {
  modalState: boolean;
  onModalStateChange: () => void;
}

export const AddSupplierModal: React.FC<IAddSupplierModal> = (props) => {
  const { onModalStateChange, modalState } = props;
  const { data: industryData = [] } = useIndustryQuery();
  const { data: typeData = [] } = useSupplierTypesListQuery();
  const { onFinish, form, onCancel, contextHolder, isLoading } = useAddSupplier({ onModalStateChange });

  return (
    <>
      {contextHolder}
      <FormModal
        form={form}
        title={'Add Supplier'}
        okText={'Add'}
        open={modalState}
        isLoading={isLoading}
        onCancel={onCancel}
        onSubmit={onFinish}
      >
        <Row gutter={[0, 20]}>
          <Col span={24}>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Item
                  label={'Supplier Name*'}
                  name={'name'}
                  rules={[{ required: true, message: ValidationErrors.required('Supplier Name') }]}
                >
                  <Input size={'large'} />
                </Item>
              </Col>
              <Col span={12}>
                <Item
                  label={'Supplier Website'}
                  name={'webSite'}
                  rules={[{ pattern: webSiteUrlRegex, message: 'Please enter a valid website URL.' }]}
                >
                  <Input size={'large'} />
                </Item>
              </Col>
              <Col span={12}>
                <Item name="mainLanguageId" label={'Main Language'}>
                  <LanguageSelect size={'large'} />
                </Item>
              </Col>
              <Col span={12}>
                <Item name="mainCountryId" label={'Main Country'}>
                  <CountrySelect size={'large'} />
                </Item>
              </Col>
              <Col span={12}>
                <Item label={'Type'} name={'type'}>
                  <Select options={typeData} size={'large'} />
                </Item>
              </Col>
              <Col span={12}>
                <Item label={'Industry'} name={'industryId'}>
                  <Select options={industryData} size={'large'} />
                </Item>
              </Col>
              <Col span={24}>
                <Item name="verified" valuePropName={'checked'}>
                  <Checkbox>
                    <Typography.Text style={{ color: '#05796b' }}>Set as verified</Typography.Text>
                  </Checkbox>
                </Item>
              </Col>
              <Col span={24}>
                <Item label={'Additional Notes'} name={'additionalNotes'}>
                  <TextArea rows={4} />
                </Item>
              </Col>
            </Row>
          </Col>
        </Row>
      </FormModal>
    </>
  );
};
